module.exports = __webpack_public_path__ + "media/images/Selecteur-503151f728d7db95abdddcca933ef4a1.svg";